<template>
  <div class="password-display">
    <div class="row">
      <label class="col-sm-4 control-label">{{ field.label }}</label>
      <div class="col-sm-8">* * * * * *</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordDisplay',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PasswordDisplay.vue?5d2bf880